const config = {
	api: 'https://sengrpg.hkust.edu.hk/summercamp/api',
	appPath: '/summercamp/app',
	loginTimeout: 18000000
};

export default config;